import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormDomainScriptGuideStatisticsService } from './statistics.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'form-domain-script-guide-features-statistics',
    standalone: false,
    templateUrl: './statistics.component.html',
})
export class FormDomainScriptGuideFeaturesStatisticsComponent implements OnInit, OnDestroy {
    @Input() domain: any;

    show: boolean = false;
    canUse: boolean = false;
    documentExts: string[] = [];
    documentClass: string = '';
    cookielessTracking: boolean = false;
    documentTracking: boolean = false;
    documentIgnoreClass: string | string[] = '';
    private subscription?: Subscription;

    constructor (
        private formDomainScriptGuideStatisticsService: FormDomainScriptGuideStatisticsService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    ngOnDestroy () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    activate () {
        this.show = this.formDomainScriptGuideStatisticsService.hasAccessToFeature();
        this.canUse = this.formDomainScriptGuideStatisticsService.getValue();
        this.documentExts = this.formDomainScriptGuideStatisticsService.getDocumentExtensions();
        this.documentClass = this.formDomainScriptGuideStatisticsService.getDocumentClass();
        this.cookielessTracking = this.formDomainScriptGuideStatisticsService.getCookielessTracking();
        this.documentTracking = this.formDomainScriptGuideStatisticsService.getDocumentTracking();
        this.documentIgnoreClass = this.formDomainScriptGuideStatisticsService.getDocumentIgnoreClass();
        this.setupWatcher();
    }

    onChangeValue () {
        setTimeout(() => {
            this.setValue(this.canUse);
        });
    }

    removeExtension (index: number) {
        this.documentExts.splice(index, 1);
        this.setDocumentExtensions(this.documentExts);
    }

    addExtension () {
        this.documentExts.push('');
        this.setDocumentExtensions(this.documentExts);
    }

    onChangeDocumentExtension () {
        setTimeout(() => {
            this.setDocumentExtensions(this.documentExts);
        });
    }

    onChangeDocumentClass () {
        setTimeout(() => {
            this.setDocumentClass(this.documentClass);
        });
    }

    onChangeCookielessTracking () {
        setTimeout(() => {
            this.setCookielessTracking(this.cookielessTracking);
        });
    }

    onChangeDocumentTracking () {
        setTimeout(() => {
            this.setDocumentTracking(this.documentTracking);
        });
    }

    onChangeDocumentIgnoreClass () {
        setTimeout(() => {
            this.setDocumentIgnoreClass(this.documentIgnoreClass as unknown as string);
        });
    }

    trackByIndex (index: number): number {
        return index;
    }

    // PROTECTED
    private setupWatcher () {
        this.subscription = this.formDomainScriptGuideStatisticsService.settingChangeObs.subscribe(() => {
            this.canUse = this.formDomainScriptGuideStatisticsService.getValue();
            this.documentExts = this.formDomainScriptGuideStatisticsService.getDocumentExtensions();
            this.documentClass = this.formDomainScriptGuideStatisticsService.getDocumentClass();
            this.cookielessTracking = this.formDomainScriptGuideStatisticsService.getCookielessTracking();
            this.documentTracking = this.formDomainScriptGuideStatisticsService.getDocumentTracking();
            this.documentIgnoreClass = this.formDomainScriptGuideStatisticsService.getDocumentIgnoreClass();
        });
    }

    private setValue (value: boolean) {
        this.formDomainScriptGuideStatisticsService.setValue(value, true);
    }

    private setDocumentExtensions (value: string[]) {
        this.formDomainScriptGuideStatisticsService.setDocumentExtensions(value, true);
    }

    private setDocumentClass (value: string) {
        this.formDomainScriptGuideStatisticsService.setDocumentClass(value, true);
    }

    private setCookielessTracking (value: boolean) {
        this.formDomainScriptGuideStatisticsService.setCookielessTracking(value, true);
    }

    private setDocumentTracking (value: boolean) {
        this.formDomainScriptGuideStatisticsService.setDocumentTracking(value, true);
    }

    private setDocumentIgnoreClass (value: string) {
        this.formDomainScriptGuideStatisticsService.setDocumentIgnoreClass(value as string, true);
    }
}
